/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuarantorMinimalDto } from './GuarantorMinimalDto';
import {
    GuarantorMinimalDtoFromJSON,
    GuarantorMinimalDtoFromJSONTyped,
    GuarantorMinimalDtoToJSON,
    GuarantorMinimalDtoToJSONTyped,
} from './GuarantorMinimalDto';
import type { TenantSeniorityStatusEnum } from './TenantSeniorityStatusEnum';
import {
    TenantSeniorityStatusEnumFromJSON,
    TenantSeniorityStatusEnumFromJSONTyped,
    TenantSeniorityStatusEnumToJSON,
    TenantSeniorityStatusEnumToJSONTyped,
} from './TenantSeniorityStatusEnum';

/**
 * 
 * @export
 * @interface TenantMinimalDto
 */
export interface TenantMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof TenantMinimalDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TenantMinimalDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof TenantMinimalDto
     */
    civilityId: string;
    /**
     * 
     * @type {string}
     * @memberof TenantMinimalDto
     */
    employmentStatusId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantMinimalDto
     */
    isSolvable: boolean;
    /**
     * 
     * @type {TenantSeniorityStatusEnum}
     * @memberof TenantMinimalDto
     */
    seniorityStatus?: TenantSeniorityStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TenantMinimalDto
     */
    rentPaymentsUpToDate?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TenantMinimalDto
     */
    monthlyAverageIncome: number;
    /**
     * 
     * @type {number}
     * @memberof TenantMinimalDto
     */
    rentToIncomeRatio: number;
    /**
     * 
     * @type {GuarantorMinimalDto}
     * @memberof TenantMinimalDto
     */
    guarantor?: GuarantorMinimalDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantMinimalDto
     */
    warningMessages?: Array<string>;
}



/**
 * Check if a given object implements the TenantMinimalDto interface.
 */
export function instanceOfTenantMinimalDto(value: object): value is TenantMinimalDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('isSolvable' in value) || value['isSolvable'] === undefined) return false;
    if (!('monthlyAverageIncome' in value) || value['monthlyAverageIncome'] === undefined) return false;
    if (!('rentToIncomeRatio' in value) || value['rentToIncomeRatio'] === undefined) return false;
    return true;
}

export function TenantMinimalDtoFromJSON(json: any): TenantMinimalDto {
    return TenantMinimalDtoFromJSONTyped(json, false);
}

export function TenantMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'],
        'civilityId': json['civilityId'],
        'employmentStatusId': json['employmentStatusId'] == null ? undefined : json['employmentStatusId'],
        'isSolvable': json['isSolvable'],
        'seniorityStatus': json['seniorityStatus'] == null ? undefined : TenantSeniorityStatusEnumFromJSON(json['seniorityStatus']),
        'rentPaymentsUpToDate': json['rentPaymentsUpToDate'] == null ? undefined : json['rentPaymentsUpToDate'],
        'monthlyAverageIncome': json['monthlyAverageIncome'],
        'rentToIncomeRatio': json['rentToIncomeRatio'],
        'guarantor': json['guarantor'] == null ? undefined : GuarantorMinimalDtoFromJSON(json['guarantor']),
        'warningMessages': json['warningMessages'] == null ? undefined : json['warningMessages'],
    };
}

export function TenantMinimalDtoToJSON(json: any): TenantMinimalDto {
    return TenantMinimalDtoToJSONTyped(json, false);
}

export function TenantMinimalDtoToJSONTyped(value?: TenantMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'civilityId': value['civilityId'],
        'employmentStatusId': value['employmentStatusId'],
        'isSolvable': value['isSolvable'],
        'seniorityStatus': TenantSeniorityStatusEnumToJSON(value['seniorityStatus']),
        'rentPaymentsUpToDate': value['rentPaymentsUpToDate'],
        'monthlyAverageIncome': value['monthlyAverageIncome'],
        'rentToIncomeRatio': value['rentToIncomeRatio'],
        'guarantor': GuarantorMinimalDtoToJSON(value['guarantor']),
        'warningMessages': value['warningMessages'],
    };
}

